import { render, staticRenderFns } from "./JSelectBukaoXuesheng.vue?vue&type=template&id=6553da25&scoped=true"
import script from "./JSelectBukaoXuesheng.vue?vue&type=script&lang=js"
export * from "./JSelectBukaoXuesheng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6553da25",
  null
  
)

export default component.exports